import { render, staticRenderFns } from "./purreceivedetailview.vue?vue&type=template&id=79e37892&scoped=true&"
import script from "./purreceivedetailview.vue?vue&type=script&lang=js&"
export * from "./purreceivedetailview.vue?vue&type=script&lang=js&"
import style0 from "./purreceivedetailview.vue?vue&type=style&index=0&id=79e37892&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e37892",
  null
  
)

export default component.exports